import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
      dataField: 'SiteCode',
      caption: 'Site',
      minWidth: COLUMN_SIZE.sm1,
      width: COLUMN_SIZE.md0,
    },
    {
      dataField: 'City',
      caption: 'City',
      minWidth: COLUMN_SIZE.sm1,
      width: COLUMN_SIZE.md1,
    },
    {
      dataField: 'Name',
      caption: 'Name',
      minWidth: COLUMN_SIZE.sm1,
      width: COLUMN_SIZE.sm1,
    },
  ];
